/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddNotesCommandResult } from '../../models/add-notes-command-result';
import { ImageRate } from '../../models/image-rate';
import { ImageWithCoordinates } from '../../models/image-with-coordinates';

export interface ApiKpiReportsAddNotePost$Plain$Params {
      body?: {
'KPIId'?: string;
'Notes'?: string;
'Attachments'?: Array<Blob>;
'Images'?: Array<ImageWithCoordinates>;
'Lat'?: number;
'Lng'?: number;
'ImageRate'?: ImageRate;
}
}

export function apiKpiReportsAddNotePost$Plain(http: HttpClient, rootUrl: string, params?: ApiKpiReportsAddNotePost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AddNotesCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiKpiReportsAddNotePost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AddNotesCommandResult>;
    })
  );
}

apiKpiReportsAddNotePost$Plain.PATH = '/api/KPIReports/AddNote';
